import type { Canvas } from 'fabric'

/**
 * Параметры для обновления и перерисовки canvas
 */
export interface UpdateAndRenderCanvasParams {
    /**
     * Текстовый объект Fabric.js (опционально)
     */
    textObj?: {
        setCoords: () => void
    }
    /**
     * Canvas Fabric.js
     */
    fabricCanvas: Canvas
}

/**
 * Обновление координат объекта и перерисовка canvas
 * Утилита для часто используемого паттерна setCoords() + renderAll()
 * @param params - параметры для обновления и перерисовки
 */
export function updateAndRenderCanvas(
    params: UpdateAndRenderCanvasParams
): void {
    const { textObj, fabricCanvas } = params

    if (textObj) {
        textObj.setCoords()
    }

    fabricCanvas.renderAll()
}
